import { Component, OnInit, Output, EventEmitter, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { DatagridComponent } from '@farris/ui-datagrid';
import { ExpressionEventService } from '../utils/expression-event-service';
import { ExpressionEditorLocalePipe } from '../utils/expression-editor-locale.pipe';
import { VarType } from './vartype';

@Component({
  selector: 'app-expression-var-grid',
  templateUrl: './expression-var-grid.component.html',
  styleUrls: ['./expression-var-grid.component.css']
})
export class ExpressionVarGridComponent implements OnInit, OnChanges {

  //定义i18n标识
  private localeId: string;
  private localePipe: ExpressionEditorLocalePipe;

  constructor(private eventService: ExpressionEventService) {
    //初始化i18n标识
    this.localeId = localStorage.getItem('languageCode') || 'zh-CHS';
    this.localePipe = new ExpressionEditorLocalePipe(this.localeId);
  }

  @Input() elements: any;
  @ViewChild('dg') dg: DatagridComponent;
  @Output() selectVarRow = new EventEmitter();
  columns = [
    { field: 'name', title: '名称' },
  ];
  items = [];

  ngOnInit() {
    this.eventService.subClearVarSelect().subscribe();
  }

  ngOnChanges() {
    if (this.elements == null) {
      this.items = [
        { name: this.localePipe.transform("VariableContextParameter"), id: VarType.Context },
        { name: this.localePipe.transform("VariableSessionValue"), id: VarType.Session }
      ]
    } else {
      if (this.elements.includes("Context")) this.items.push({ name: this.localePipe.transform("VariableContextParameter"), id: VarType.Context });
      if (this.elements.includes("Session")) this.items.push({ name: this.localePipe.transform("VariableSessionValue"), id: VarType.Session });
    }

    this.items = [...this.items];
  }

  selectRowChange($event) {
    this.eventService.subClearVarSelect().subscribe();
    this.dg.clearCheckeds();
    this.selectVarRow.emit($event.data);
  }
}
